const STORAGE_KEY_PREFIX = 'logistics_rfq_pending_submit';

function storageKey(rfqKind = 'generic') {
  const kind = String(rfqKind || 'generic').trim().toLowerCase().replace(/_/g, '-');
  return `${STORAGE_KEY_PREFIX}_${kind}_v1`;
}

export function saveLogisticsRfqPendingSubmit(data) {
  try {
    const key = storageKey(data?.rfqKind);
    sessionStorage.setItem(key, JSON.stringify({ ...data, savedAt: new Date().toISOString() }));
    return true;
  } catch {
    return false;
  }
}

export function loadLogisticsRfqPendingSubmit(rfqKind = 'generic') {
  try {
    const raw = sessionStorage.getItem(storageKey(rfqKind));
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearLogisticsRfqPendingSubmit(rfqKind = 'generic') {
  try {
    sessionStorage.removeItem(storageKey(rfqKind));
  } catch {
    /* ignore */
  }
}
